// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-754a38aa] {\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.card .title[data-v-754a38aa] {\n  font-size: 1.5rem;\n  margin-top: 0.5rem;\n}\n.card .content[data-v-754a38aa] {\n  margin: 0;\n}\n.card .date[data-v-754a38aa] {\n  font-size: 1.2rem;\n  margin-bottom: 0;\n  margin-top: 0.75rem;\n  text-align: right;\n}\n.card .date svg[data-v-754a38aa] {\n  font-size: 0.9rem;\n  margin-right: 3px;\n  position: relative;\n  top: -1px;\n}", ""]);
// Exports
module.exports = exports;
